import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import {
    InvoiceStatus,
    InvoiceResponse
} from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { billingModalInvoicesAddToGridColumnDefs } from '@/modules/billing-module/components/modal/invoices/add-to/config/billing-modal-invoices-add-to-grid.column-defs'
import { billingCommonInvoiceService } from '@/api/services/billing/common-invoice/billing-common-invoice.service'
import { BillableDeliveryNoteResponse } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { AgColumnDefinition, IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { store } from '@/store/store'
import { GridUtils } from '@/shared/util/grid-utils'

export class BillingModalInvoicesAddToGridDatasource extends PaginatorLaboratoryDatasource<InvoiceResponse> {
    public readonly deliveryNotes: BillableDeliveryNoteResponse[]

    constructor(deliveryNotes: BillableDeliveryNoteResponse[]) {
        super(billingCommonInvoiceService, store.getters.labId)
        this.deliveryNotes = deliveryNotes
    }

    public getColumnDefs(): AgColumnDefinition[] {
        return billingModalInvoicesAddToGridColumnDefs()
    }
    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<InvoiceResponse>> {
        const _filterModel: CommonFilterModel = { ...filterModel }
        if (this.deliveryNotes.length) {
            const invoice = this.deliveryNotes[0]

            _filterModel['status'] = GridUtils.getSetFilterModel([InvoiceStatus.GENERATED])

            if (invoice.conceptsAccountingUnit) {
                _filterModel['conceptsAccountingUnit.id'] =
                    GridUtils.getNumberFilterModel('equals', invoice.conceptsAccountingUnit.id)
            }

            _filterModel['isForAutoInvoice'] =
                GridUtils.getSetFilterModel([`${invoice.isForAutoInvoice}`])

            if (invoice.customer) {
                _filterModel['customer.id'] =
                    GridUtils.getNumberFilterModel('equals', invoice.customer.id)
            } else if (invoice.patient) {
                _filterModel['patient.id'] =
                    GridUtils.getNumberFilterModel('equals', invoice.patient.id)
            }
        }
        return billingCommonInvoiceService.paginator(_filterModel, params, this.laboratoryId)
    }
}
